import { render, staticRenderFns } from "./MailTaskDetail.vue?vue&type=template&id=1e14f966&"
import script from "./MailTaskDetail.vue?vue&type=script&lang=js&"
export * from "./MailTaskDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e14f966')) {
      api.createRecord('1e14f966', component.options)
    } else {
      api.reload('1e14f966', component.options)
    }
    module.hot.accept("./MailTaskDetail.vue?vue&type=template&id=1e14f966&", function () {
      api.rerender('1e14f966', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/gva-wfd/components/DetailPanel/MailTaskDetail.vue"
export default component.exports